// @ts-nocheck
/* eslint-disable */
export const triangleFlagIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#172E63" d="M6.45 22c-.41 0-.75-.34-.75-.75V2.75c0-.41.34-.75.75-.75s.75.34.75.75v18.5c0 .41-.34.75-.75.75"/><path fill="#172E63" d="m15.2 7.16-8.1-3.5a.36.36 0 0 0-.36.03.37.37 0 0 0-.16.31v13c0 .13.07.25.18.32.06.04.13.06.2.06.06 0 .11-.01.17-.04l8.3-4.1h.01c1.66-.86 2.55-1.97 2.5-3.14-.06-1.18-1.03-2.22-2.74-2.94" opacity=".4"/></svg>`,
    name: 'triangle-flag' as const
};